<template>
  <div>
    <v-flex p-t-30>
      <div class="tituloBox p-b-30 border-top">
        <div class="bg-primary barraTitulo"></div>
        <h1 class="text-info font-size-18">
          Cadastrar
          <strong>Formulários e declarações</strong>
        </h1>
      </div>
    </v-flex>
    <v-flex>
      <v-card>
        <v-layout row wrap class="p-t-10 p-b-20">
          <v-flex xs12 sm12 md12
            v-for="item in fornecedorDeclaracaoVm.lista.filter(x=>x.uploadDeclaracao.exibe && (!(x.uploadDeclaracao.tipDocumento == 150 && x.uploadDeclaracao.uploadDeclaracaoSituacao == 2) && !(x.uploadDeclaracao.tipDocumento == 150 && $verificaPerfilCadastrador())) )"
            :key="item.uploadDeclaracao.chave+''+item.uploadDeclaracao.tipoDocumento"
          >
        
            <v-toolbar class="toolbar__title" light height="50px" v-if="![161,162].includes(item.uploadDeclaracao.tipDocumento)"  >
              <v-toolbar-title class="toolbar__title" v-if="ValidaObrigatorio(item.uploadDeclaracao.descricao)">
                <h6 class="titulo" >{{item.uploadDeclaracao.descricao}}</h6>
              </v-toolbar-title>
              <v-toolbar-title class="toolbar__title" v-else-if="ValidaNaoObrigatorio(item.uploadDeclaracao.descricao)">
                <h6 class="titulo" >{{item.uploadDeclaracao.descricao}}</h6>                
              </v-toolbar-title>
              <v-toolbar-title class="toolbar__title" v-else>
                <h6 class="titulo" >{{item.uploadDeclaracao.descricao}}*</h6>                
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon  @click="openBox(item)">
                <v-icon color="primary">unfold_more</v-icon>
              </v-btn>
            </v-toolbar>

            <v-layout v-show="(isShow[item.uploadDeclaracao.chave+''+item.uploadDeclaracao.tipoDocumento] || aberto) && (item.uploadDeclaracao.chave !== 'TermoConcordanciaVeracidadeSaeb' && ![161,162].includes(item.uploadDeclaracao.tipDocumento))"  >

              <!--
                  TODO
                  Colocar aqui o componente de Download com o tamanho de md6
                  criar um IF para cada exibição de documento pelo código
              -->

              <v-flex  cols12 sm12 md6 >

                <!--Este If é para não aparecer o campo de procuração -->
                <!--Este If é para não aparecer o campo de Comprovante de Residência -->
                <!--  v-if="item.uploadDeclaracao.chave != ('Procuracao') " -->
                <div >
                    
                    <textFieldDeclaracoesArquivos
                      v-if="[64,71,99,100].includes(item.uploadDeclaracao.tipDocumento)"
                      :label="'Modelo '+ item.uploadDeclaracao.descricao"
                      :arquivoUpload="item.uploadDeclaracao.arquivoUpload"
                      :arquivoUploadSituacao="item.uploadDeclaracao.uploadDeclaracaoSituacao"
                      :codDocumento="''+item.uploadDeclaracao.tipDocumento"
                    ></textFieldDeclaracoesArquivos>

                </div>
              </v-flex><br>             
             <v-flex xs12 sm12 md6>
            <!-- Campo de upload (já existente) -->
            <div class="inputIcon" v-show="!item.file.novo">
              <v-text-field
                :value="subStrUpload(item.uploadDeclaracao.arquivoUpload, item.uploadDeclaracao.nomDocumento)"
                :label="item.uploadDeclaracao.descricao + testeAsterisco(item.uploadDeclaracao.obrigatorio)"
                clearable
                append-icon="get_app"
                readonly
                @click:append="baixarArquivo(item.uploadDeclaracao.arquivoUpload)"
                @click:clear="item.file.novo = true; item.uploadDeclaracao.arquivoUpload = null; item.file.arquivoUpload=null"
                :hint="ifuploadDeclaracaoAlterado(item.uploadDeclaracao.arquivoUpload,item.uploadDeclaracao.tipDocumento,'tipDocumento')"
                persistent-hint
              ></v-text-field>
            </div>

            <uploadFile
              v-if="item.file.novo"
              tamanhoMaximo="20MB"
              :required="item.uploadDeclaracao.tipDocumento === 71 
                || (item.uploadDeclaracao.tipDocumento !== 119 
                && model.flagEstrangeiro !== 1 
                && model.tipFornecedor !== 'F' 
                && item.uploadDeclaracao.obrigatorio
                && item.file.novo)"
              :label="item.uploadDeclaracao.descricao + testeAsterisco(item.uploadDeclaracao.obrigatorio || item.uploadDeclaracao.tipDocumento === 71)"
              v-model="item.file.arquivoUpload"
              @input="handleFileInput(item)"
              accept=".pdf, .PDF"
            />

            <!-- ✅ Campo de Data de Validade (apenas para Procuração - 119) -->
           <div v-if="item.uploadDeclaracao.tipDocumento === 119 && (isShow[item.uploadDeclaracao.chave+''+item.uploadDeclaracao.tipoDocumento] || aberto)">
            <datePicker
              v-model="item.uploadDeclaracao.dtVencimento"
              :dataDefault="item.uploadDeclaracao.dtVencimento"
              :label="$t('label.dataValidade')"
              :required="false"
              @change="alteracaoValorCampo(item.uploadDeclaracao)"
              validate-on-blur
              persistent-hint
              :clearable="true"
              :key="'dtVencimento-' + item.uploadDeclaracao.chave + item.uploadDeclaracao.tipoDocumento"
              :rules="[
                v => !v || validaDataVencida(v) || 'Data de Validade da Procuração Vencida.'
              ]"
              :testarDataVencida="true"
            />
          </div>
          </v-flex>

           
            </v-layout>
            
            <v-layout v-if="item.uploadDeclaracao.tipDocumento == 150 && item.uploadDeclaracao.uploadDeclaracaoSituacao != 2 && !$verificaPerfilCadastrador()"> 
                           
              <!-- Pessoa Juridica Assinado digitalmente -->
               <v-flex xs6 sm6 md6></v-flex>
               
               <v-flex xs6 sm6 md6>
                <v-flex xs12 sm12 md12>
                    <legend style="margin-top:20px">
                            <v-btn 
                    slot="activator" 
                    color="primary" 
                    class="mb-2" 
                    @click="termoConcordancia(3)"
                    :disabled="false"
                    >Emitir Termo de Declaração de Concordância e Veracidade</v-btn>
                  </legend>
                  </v-flex>  
                  <v-flex xs12 sm12 md12>
                    <legend style="margin-top:20px">
                      <strong class="text-primary">Possui Assinatura digital ?</strong>
                    </legend>
                  </v-flex>  
                  
                  <!-- CheckBoxes certificado digital -->
                  <v-layout>
                    <v-flex xs6 sm6 md6 >
                      <v-checkbox v-model="chkSingYes" 
                        required
                        :true-value="true"
                        :false-value="null"
                        :rules="rulesCertificado"
                        v-on:change="exibirTermo()"
                      >
                        <div slot="label">
                          <a @click='abrirTermos()' href="javascript:void(0)">Sim</a>
                        </div>  
                      </v-checkbox> 
                    </v-flex>
                    <v-flex xs6 sm6 md6 >
                      <v-checkbox v-model="chkSingYes"
                        required
                        :true-value="false"
                        :false-value="null"
                        :rules="rulesCertificado"
                        hide-details
                        v-on:change="exibirTermo()"
                      >
                        <div slot="label">
                        <a @click='abrirTermos()' href="javascript:void(0)">Não</a>
                        </div>  
                      </v-checkbox>
                    </v-flex>
                  </v-layout>

                  <!-- CheckBoxes tipo do certificado digital -->
                  <div v-if="chkSingYes">
                      <v-flex xs12 sm12 md12>
                        <legend>
                          <strong class="text-primary">A Assinatura digital é de qual natureza ?</strong>
                        </legend>
                      </v-flex>
                    
                      <v-layout>
                        <v-flex xs6 sm6 md6>
                          <v-checkbox v-model="chkPessoaFisica"
                            required
                            :true-value="false"
                            :false-value="true"
                            :rules="rulesTipoPessoaCertificado"
                          >
                            <div slot="label">
                            <a @click='abrirTermos()' href="javascript:void(0)">Pessoa Jurídica</a>
                            </div>  
                          </v-checkbox>
                        </v-flex>  
                        <v-flex xs6 sm6 md6>
                          <v-checkbox v-model="chkPessoaFisica"
                            required
                            :true-value="true"
                            :false-value="false"
                            :rules="rulesTipoPessoaCertificado"
                            hide-details                            
                          >
                            <div slot="label">
                            <a @click='abrirTermos()' href="javascript:void(0)">Pessoa Física</a>
                            </div>  
                          </v-checkbox> 
                        </v-flex>
                      </v-layout>                    
                      <!-- Upload do termo de concordancia -->
                      <v-layout v-if="chkSingYes">
                      
                        <v-layout v-show="(isShow[item.uploadDeclaracao.chave+''+item.uploadDeclaracao.tipoDocumento] || aberto)">
                          <!-- #149537 - Removido a verificação testeAsterisco(item.uploadDeclaracao.obrigatorio) para o termo de veracidade
                          pois o campo só será exibido quando for obrigatório, então sempre terá o ' *' -->
                            <v-flex  cols12 sm12 md12 >
                              <div class="inputIcon" v-show="!item.file.novo">
                               
                             
                                      <v-text-field
                                        :value="subStrUpload(item.uploadDeclaracao.arquivoUpload,item.uploadDeclaracao.arquivoUpload)"
                                        :label="item.uploadDeclaracao.descricao + '*'"
                                        clearable
                                        append-icon="get_app"
                                        readonly
                                        @click:append="baixarArquivo(item.uploadDeclaracao.arquivoUpload)"
                                        @click:clear="item.file.novo = true; item.uploadDeclaracao.arquivoUpload = null; item.file.arquivoUpload=null"
                                        :hint="ifuploadDeclaracaoAlterado(item.uploadDeclaracao.arquivoUpload,item.uploadDeclaracao.tipDocumento,'tipDocumento')"
                                        persistent-hint
                                      ></v-text-field>
                              </div>

                              <uploadFile
                                v-if="item.file.novo"
                                tamanhoMaximo="20MB"
                                :required="chkSingYes && item.file.novo"
                                :label="item.uploadDeclaracao.descricao + ' assinado*'"
                                v-model="item.file.arquivoUpload"
                                accept=".pdf, .PDF"
                              />

                            </v-flex>
                      </v-layout>
                      </v-layout>
                    </div>

               </v-flex> 
            </v-layout>

            <!-- Outros Documentos-->
            
            <!-- Doc de Identificação - Pessoa Juridica Assinado digitalmente com certificado Pessoa Física-->
            <v-layout v-if="item.uploadDeclaracao.tipDocumento == 162 "> 
              <v-flex xs6 sm6 md6></v-flex>
              <v-flex xs6 sm6 md6>
                <div v-if="chkSingYes || item.uploadDeclaracao.arquivoUpload != null">
                    <!-- Upload do Doc de Identificação Pessoa Física representando PJ assinante termo de concordancia -->
                    <v-layout v-if="(chkSingYes && chkPessoaFisica) || item.uploadDeclaracao.arquivoUpload != null ">

                      <v-layout v-show="(isShow[item.uploadDeclaracao.chave+''+item.uploadDeclaracao.tipoDocumento] || aberto)">

                          <v-flex  cols12 sm12 md12 >
                            <div class="inputIcon" v-show="!item.file.novo">
                                    <v-text-field
                                      :value="subStrUpload(item.uploadDeclaracao.arquivoUpload,item.uploadDeclaracao.nomDocumento)"
                                      :label="'RG, CPF ou Documento equivalente*'"
                                      clearable
                                      append-icon="get_app"
                                      readonly
                                      @click:append="baixarArquivo(item.uploadDeclaracao.arquivoUpload)"
                                      @click:clear="item.file.novo = true; item.uploadDeclaracao.arquivoUpload = null; item.file.arquivoUpload=null"
                                      :hint="ifuploadDeclaracaoAlterado(item.uploadDeclaracao.arquivoUpload,item.uploadDeclaracao.tipDocumento,'tipDocumento')"
                                      persistent-hint
                                    ></v-text-field>
                            </div>

                            <uploadFile
                              v-if="item.file.novo"
                              tamanhoMaximo="20MB"
                              :required="chkPessoaFisica && item.file.novo"
                              :label="'RG, CPF ou Documento equivalente*'"
                              v-model="item.file.arquivoUpload"
                              accept=".pdf, .PDF"
                            />

                          </v-flex>
                    </v-layout>
                    </v-layout>
                </div>
              </v-flex> 
            </v-layout>
            
            <!-- Procuração - Pessoa Juridica Assinado digitalmente com certificado Pessoa Física-->
            <v-layout v-if="item.uploadDeclaracao.tipDocumento == 161 && chkSingYes "> 
              <v-flex xs6 sm6 md6></v-flex>
              <v-flex xs6 sm6 md6>
                  <div v-if="chkSingYes || item.uploadDeclaracao.arquivoUpload != null">
                    
                      <!-- Upload da Procuração Pessoa Física representando PJ assinante termo de concordancia -->
                      <v-layout v-if="(chkSingYes && chkPessoaFisica) || item.uploadDeclaracao.arquivoUpload != null">

                        <v-layout v-show="(isShow[item.uploadDeclaracao.chave+''+item.uploadDeclaracao.tipoDocumento] || aberto)">

                            <v-flex  cols12 sm12 md12 >
                              <div class="inputIcon" v-show="!item.file.novo">
                                      <v-text-field
                                        :value="subStrUpload(item.uploadDeclaracao.arquivoUpload,item.uploadDeclaracao.nomDocumento)"
                                        :label="item.uploadDeclaracao.descricao + testeAsterisco(item.uploadDeclaracao.obrigatorio)"
                                        clearable
                                        append-icon="get_app"
                                        readonly
                                        @click:append="baixarArquivo(item.uploadDeclaracao.arquivoUpload)"
                                        @click:clear="item.file.novo = true; item.uploadDeclaracao.arquivoUpload = null; item.file.arquivoUpload=null"
                                        :hint="ifuploadDeclaracaoAlterado(item.uploadDeclaracao.arquivoUpload,item.uploadDeclaracao.tipDocumento,'tipDocumento')"
                                        persistent-hint
                                      ></v-text-field>
                              </div>

                              <uploadFile
                                v-if="item.file.novo"
                                tamanhoMaximo="20MB"
                                :required="item.uploadDeclaracao.obrigatorio && item.file.novo"
                                :label="item.uploadDeclaracao.descricao + testeAsterisco(item.uploadDeclaracao.obrigatorio)"
                                v-model="item.file.arquivoUpload"
                                accept=".pdf, .PDF"
                              />

                            </v-flex>
                      </v-layout>
                      </v-layout>
                  </div>
              </v-flex> 
            </v-layout>
       </v-flex>
          
        <v-flex xs12 sm12 md12 v-for="doc in listaDocFornecSolicitacao.filter(documento =>
        documento.numHabilitacao === '2'
        &&   documento.codDocumento != 32
        && (
          (model.finalidadeEmpresa == 0 && documento.indSemFinsLucrativos != '1') 
          || (model.finalidadeEmpresa == 1 && documento.indSemFinsLucrativos != '1' && model.flagSociedadeAnonima == 1)
          || (model.finalidadeEmpresa == 1 && documento.indComFinsLucrativos != '1' && (model.flagSociedadeAnonima == 0 || model.flagSociedadeAnonima === null))
        ))" :key="doc.codDocumento">
<v-layout v-if="(doc.codDocumento == 146 || doc.codDocumento == 145 || doc.codDocumento == 143) && chkSingYes && fornecedorDeclaracaoVm.lista.some(x => x.uploadDeclaracao.tipDocumento == 150 && x.uploadDeclaracao.uploadDeclaracaoSituacao != 2)"> 
          <v-flex xs6 sm6 md6></v-flex>
              <v-flex xs6 sm6 md6>
                <v-layout v-if="(chkSingYes && chkPessoaFisica) || doc.arquivoUpload != null">
               <v-flex inputIcon cols12 sm12 md12 v-show="doc.docSolicitacao.arquivoUpload != null">
              <v-text-field
                :value="subStrUpload(doc.docSolicitacao.arquivoUpload,'Anexo do '+ titleCase(doc.nomDocumento))"
                :label="'Anexo do(a) '+ titleCase(doc.nomDocumento) "                
                append-icon="get_app"
                readonly
                @click:append="baixarArquivo(doc.docSolicitacao.arquivoUpload)"
              ></v-text-field>
            </v-flex>
            <v-flex cols12 sm12 md12 v-if="doc.docSolicitacao.arquivoUpload == null">
              <uploadFile
                tamanhoMaximo="20MB"
                :required="doc.indSemFinsLucrativos == '3' || doc.indComFinsLucrativos == '3' || (doc.nomDocumento === 'ATA' && model.finalidadeEmpresa === 0)"
                :label="'Anexar '+ titleCase(doc.nomDocumento) "
                v-model="doc.file"
                accept=".pdf, .PDF"
                @input="handleFileChange(doc, doc.file)"
              />
            </v-flex>  
          </v-layout>
          </v-flex> 
           
            </v-layout>
			 </v-flex> 
      
      </v-layout>

        <v-dialog v-model="dialogTermo" persistent width="100%">
          <v-card>          
            <v-card-text>
              <TermoDeclaracaoConcordancia :idFornecSolicitacaoProps="model.idFornecSolicitacao"
              v-on:retornoDialogTermoFechar="obterDialogTermoRef"
              >
              </TermoDeclaracaoConcordancia>
            </v-card-text>
            <!-- <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info" @click="dialogPop = false">Fechar</v-btn>
            </v-card-actions> -->
          </v-card>
        </v-dialog>
      </v-card>
    </v-flex>
  </div>
</template>
<script>
import util from "../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import textFieldDeclaracoesArquivos from "../../components/text-field-declaracoes-arquivos";
import documentosService from "../../services/documentosFornecService";
import fornecedorService from "../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import uploadDeclaracaoService from "../../services/uploadDeclaracaoService";
import analiseCampoAlterado from "../../feature/area-restrita/fornecedor/components/analiseCampoAlterado";
import TermoDeclaracaoConcordancia from './termo-declaracao-concordancia';


export default {
  name: "formularios-declaracoes",
  mixins: [util,analiseCampoAlterado],
  components: {
    /*Componentes utilizados*/
    textFieldDeclaracoesArquivos,
    TermoDeclaracaoConcordancia,
  },
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    fornecedorDeclaracaoVm: Object,
    enums: Object,
    OldModel: Object,
    listaDocFornecSolicitacao: Array,
  },
  created() /*Metodo de start do componente*/{
    this.carregarTela();
   
    var DocFornec = this.fornecedorDeclaracaoVm.lista.filter(x=> (x.uploadDeclaracao.tipDocumento == 161  || x.uploadDeclaracao.tipDocumento == 162) && x.uploadDeclaracao.arquivoUpload != null ) 
    var DocTermo = this.fornecedorDeclaracaoVm.lista.filter(x=> x.uploadDeclaracao.tipDocumento == 150  && x.uploadDeclaracao.arquivoUpload != null ) 

    //this.getDocumentosFornecedor(this.model.idFornecSolicitacao);
    if(DocFornec.length > 0){
      this.chkPessoaFisica = true
      this.chkSingYes = true    
      this.model.possuiCertificadoDigital = "1";    
    }
    else{
      this.chkPessoaFisica = false     
    }
 
    if(DocTermo.length > 0 && DocFornec.length == 0){     
      this.model.possuiCertificadoDigital = "1";    
  
      this.chkSingYes = true
    }
    if(this.model.possuiCertificadoDigital == "1"){
     
      this.chkSingYes = true;
    }
   
  
  },
    watch: { //Propriedades assistidas
    "model.uploadDeclaracao":{
      handler(newValue) { /*Se houver um novo valor*/
        this.carregarTela();
      },
      // chkSingYes(){
      //   this.chkSingNo = !this.chkSingYes;
      //   console.log(this.chkSingNo);
      // }
    }
  },
  data() {//Declaracao de variaveis
    return {
      //listaDocFornecSolicitacao: [],
      disableUpload: {
        99: false, // Controle de desabilitação para o tipo 99
        100: false // Controle de desabilitação para o tipo 100
      },
      isShow: [],
      aberto: true,
      chkSingYes: false,      
      chkPessoaFisica: null,
      chkPessoaJuridica: false,
      dialogTermo: false,
    }
  },
  computed:{
    rulesCertificado(){
      return [ this.chkSingYes !== null || 'Selecione uma opção'];
    },
    rulesTipoPessoaCertificado(){

      if (!this.chkPessoaFisica) {
        this.fornecedorDeclaracaoVm.lista.forEach(item => {
            if (
              (item.uploadDeclaracao.tipDocumento === 161 || item.uploadDeclaracao.tipDocumento === 162) &&
              item.uploadDeclaracao.arquivoUpload !== null
            ) {
              // Transforme o arquivoUpload em null para os itens que atendem ao filtro
              item.file.novo = true;
              item.uploadDeclaracao.arquivoUpload = null;
            }
          });
      }
 
      return [ this.chkPessoaFisica !== null || 'Selecione uma opção'];
    },
    condicaoParaMarcarPessoaFisica() {
      // Sua lógica de validação aqui
      var docx = this.fornecedorDeclaracaoVm.lista.filter(x => x.uploadDeclaracao.tipDocumento == 161);      
      return docx.arquivoUpload != null;
    }
  },
  methods: {//Declaracao de todos os metodos
 handleFileInput(item) {
  const tipoDocumento = item.uploadDeclaracao.tipDocumento;

  if (tipoDocumento === 99) {
    this.$set(this.disableUpload, 100, true);

    this.fornecedorDeclaracaoVm.lista.forEach((x) => {
      if (x.uploadDeclaracao.tipDocumento === 100) {
        this.$set(x.file, 'novo', false);  // 🔹 Força reinicialização
        this.$set(x.uploadDeclaracao, 'arquivoUpload', null);
        this.$set(x.file, 'arquivoUpload', null);
        
        // 🔹 Garante que o componente será recriado
        this.$set(x, 'key', Date.now());

        // 🔹 Atraso pequeno para permitir o Vue processar antes de reativar
        setTimeout(() => {
          this.$set(x.file, 'novo', true);
        }, 10);
      }
    });

    // Reabilita o upload do tipo 99
    this.$set(this.disableUpload, 99, false);
  } else if (tipoDocumento === 100) {
    this.$set(this.disableUpload, 99, true);

    this.fornecedorDeclaracaoVm.lista.forEach((x) => {
      if (x.uploadDeclaracao.tipDocumento === 99) {
        this.$set(x.file, 'novo', false);  // 🔹 Força reinicialização
        this.$set(x.uploadDeclaracao, 'arquivoUpload', null);
        this.$set(x.file, 'arquivoUpload', null);

        // 🔹 Garante que o componente será recriado
        this.$set(x, 'key', Date.now());

        // 🔹 Atraso pequeno para permitir o Vue processar antes de reativar
        setTimeout(() => {
          this.$set(x.file, 'novo', true);
        }, 10);
      }
    });

    // Reabilita o upload do tipo 100
    this.$set(this.disableUpload, 100, false);
  }
}
,

    baixarArquivo(arquivo) {
      //metodo para baixar os documentos
      const numCgcFornecedor = this.model.numCgcFornecedor.replace(/[\W_]+/g,"");
      fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
    },
    getDocumentosFornecedor(idFornecSolicitacao){
      //resgatar documentos do fornecedor
      documentosService.getDocumentosFornecedorSolicitacao(idFornecSolicitacao).then(response => { /*resposta do servico*/
        this.listaDocFornecSolicitacao = response.data; /*dados de retorno*/
        if (this.listaDocFornecSolicitacao.find(x=> x.codDocumento == 140).docSolicitacao.arquivoUpload)
          this.upload.novoRG = false
      });
    },
    handleFileChange(doc, file) {
    Vue.set(doc, 'file', file); // Garante a reatividade ao atualizar doc.file
    this.$emit('update-doc', doc);
   },
    limparArquivo(doc) {
      //item da iteração mudar
      doc.docSolicitacao.arquivoUpload=null;
      doc.file=null
      if (this.isAlteracao)
      {
        doc.docSolicitacao.datExpedicao = null
        this.dataContratoSocialKey++;
      }
    },
    termoConcordancia(config) {
      const url = "/termo-declaracao-concordancia/" + this.model.idFornecSolicitacao + "/" +config;
          const newTab = document.createElement("a");
          newTab.href = url;
          newTab.target = "_blank";
          newTab.click();
      },
     
    testeAsterisco(valor) {
      return valor ? " *" : "";
    },
    openBox(item, isShow) {
      const flag = this.isShow.includes( item.uploadDeclaracao.chave+''+item.uploadDeclaracao.tipoDocumento ) ;
      if(flag){
        this.$set(this.isShow, item.uploadDeclaracao.chave + "" + item.uploadDeclaracao.tipoDocumento, !flag);
      }

    },
    subStrUpload(str) {
      var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;

      //Se for link
      if(regex .test(str)) {
        return  str.substring(0,35)+'...';
      }
      return str != null ? str.substring(str.indexOf("_") + 1) : str;
    },
    ValidaObrigatorio(valor) {
    if(valor.toUpperCase() == 'PROCURAÇÃO' || valor.toUpperCase() == 'COMPROVANTE DE RESIDÊNCIA')
    {return true;}
    return false;
    },
    ValidaNaoObrigatorio(valor){
      if(valor.toUpperCase() === 'DECLARAÇÃO DE ENQUADRAMENTO' || valor.toUpperCase() === 'DECLARAÇÃO DE DESENQUADRAMENTO'){
        return true;
      }
        return false;
    },
    alteracaoValorCampo(dadosDocumento){
        let arrayDocs = this.model.uploadDeclaracao;
        let self = this; 
        arrayDocs.forEach(function (item){
            if (item.tipDocumento === dadosDocumento.tipDocumento){
              item.uploadDeclaracaoSituacao = null;
              item.dtRejeicao = null;
              item.idMotivoIndeferimentoArquivo = null;
              self.$set(item, 'uploadDeclaracaoSituacao', null);
              self.$set(item, 'dtVencimento', dadosDocumento.dtVencimento);
            }  
        });
    },
    carregarTela() {
      // Método para carregar os possíveis documentos para cadastro em tela
      var lista = [];
      const listaAtual = this.fornecedorDeclaracaoVm.lista || [];

      // Verifica se o Termo de Concordância está deferido
      const termoConcordancia = this.model.uploadDeclaracao.find(
        item => item.tipDocumento === 150 && item.uploadDeclaracaoSituacao === 2 // 150 = Termo de Concordância e Veracidade, 2 = Aprovado
      );

      this.enums.tipoUploadDeclaracao.filter(item => {
        let dec = {
          chave: item.chave,
          idUploadDeclaracao: null,
          idFornecSolicitacao: this.model.idFornecSolicitacao,
          tipDocumento: item.valor,
          uploadDeclaracaoSituacao: null,
          descricao: item.descricao,
          arquivoUpload: null,
          idMotivoIndeferimentoArquivo: null,
          obrigatorio: false,
          exibe: true
        };

        if (Number(item.valor) === 182) {
          dec.exibe = false;
        }

        // Exclui documentos relacionados ao termo se ele estiver deferido
        if (
          termoConcordancia &&
          (item.valor === 161 || item.valor === 162) // 161 = Procuração - Termo, 162 = Doc. Identificação - Termo
        ) {
          dec.exibe = false;
        }

        if (this.model.flagEstrangeiro === '1') {
          // Se for estrangeiro
          dec.obrigatorio = false;
          if (dec.chave === 'Procuracao') {
            dec.obrigatorio = true;
            dec.descricao = this.$t('label.procuracaoEstrangeiro');
          }
        }

        dec = this.verificaSupervenienciaEmpregador(dec);

        // Testar se exibe o campo em tela
        if (!dec.obrigatorio && this.model.tipoCertificado === 3) {
          if (
            dec.chave === "DeclaracaoEmpregador" ||          
            dec.chave === "DeclaracaoEnquadramento" || 
            dec.chave === "DeclaracaoDesenquadramento"
          ) {
            dec.exibe = false;
          }
        }

        let mv = this.model.uploadDeclaracao.find(
          x => x.tipDocumento === item.valor
        );

        if (mv) {
         this.$set(dec, 'dtVencimento', mv.dtVencimento ? mv.dtVencimento.split('T')[0] : null);
          dec.arquivoUpload = mv.arquivoUpload;
          dec.uploadDeclaracaoSituacao = mv.uploadDeclaracaoSituacao;
          dec.idMotivoIndeferimentoArquivo = mv.idMotivoIndeferimentoArquivo;
          dec.idUploadDeclaracao = mv.idUploadDeclaracao;
        }

        if (dec.exibe === true) {
          const itemAtual = listaAtual.find(
            item => Number(item.uploadDeclaracao && item.uploadDeclaracao.tipDocumento) === Number(item.valor)
          );
          const arquivoPendente = [64, 71].includes(Number(item.valor)) &&
            itemAtual && itemAtual.file && itemAtual.file.arquivoUpload;

          lista.push({
            uploadDeclaracao: dec,
            file: {
              arquivoUpload: arquivoPendente || null,
              novo: arquivoPendente ? true : (dec.arquivoUpload ? false : true)
            }
          });
        }
      });

      // Forçar a procuração do termo a ser o último elemento na lista
      let procuracaoTermo = lista.filter(item =>  
        item.uploadDeclaracao.tipDocumento == 161);

      lista = lista.filter(item =>
        item.uploadDeclaracao.tipDocumento != 161 );
      
      if (procuracaoTermo.length > 0) {
        lista.push(procuracaoTermo[0]);
      }

      this.fornecedorDeclaracaoVm.lista = lista;
    },

    /* verifica de é Declaração de Superveniência e
     certificado diferente de CRE */
     verificaCertificadoSuperveniencia(dec){
      if (dec.chave === "DeclaracaoSuperveniencia") {
        dec.obrigatorio = true;
      }

      return dec;
    },

    /* Declaração do Empregador, Declaração de Superveniência e
     certificado diferente de CRE */
     verificaSupervenienciaEmpregador(dec){
      if ((dec.chave === "DeclaracaoEmpregador" && this.model.tipoCertificado !== 3) || (dec.chave === "DeclaracaoSuperveniencia" ))
       {
        dec.obrigatorio = true;
      }
      return dec;
    },
     validaDataVencida(data) {
  
      if (!data) return true;

      let dataAtual = new Date();
      let dataFormatada = dataAtual.toISOString().split('T')[0];      

      const partes = data.split('/');
      const novaData = `${partes[2]}-${partes[1]}-${partes[0]}`;
      
      if(novaData < dataFormatada) {        
        return false;
      }    
      
      return true;
    },
    aprovar(itemLista) {
      //metodo para aprovar o documento
      let model = Object.assign({}, itemLista);
      model.uploadDeclaracaoSituacao = 2;
      model.idMotivoIndeferimentoArquivo = null;
      uploadDeclaracaoService.aprovarRejeitar(model).then(response => { /*resposta do servico*/
        this.model.uploadDeclaracao = response.data; /*dados de retorno*/
        this.carregarTela();
        this.$toasted.success(this.$t("messages.cadastro.aprovadoComSucesso"));
      });
    },

    rejeitar(itemLista,motivo) {
      //metodo para rejeitar o documento
      const selecao = motivo && typeof motivo === 'object'
        ? motivo
        : { motivoSelecionado: motivo, motivoSelecionado2: null, motivoSelecionado3: null };

      let model = Object.assign({},itemLista);
      model.uploadDeclaracaoSituacao = 1;
      model.idMotivoIndeferimentoArquivo = selecao.motivoSelecionado;
      model.idMotivoIndeferimentoArquivo2 = selecao.motivoSelecionado2;
      model.idMotivoIndeferimentoArquivo3 = selecao.motivoSelecionado3;
      uploadDeclaracaoService.aprovarRejeitar(model).then(response => { /*resposta do servico*/
        this.model.uploadDeclaracao = response.data; /*dados de retorno*/
        this.carregarTela();
        this.fnAcaoModalCancelar();
        this.$toasted.success(this.$t("messages.cadastro.rejeitadoComSucesso"));
      });
    },

    fnAcaoModalCancelar() {
      //metodo para cancelar o rejeite do documento antes da persistencia
      this.modelDialogRejeitar.open = false;
    },
   
    exibirTermo(){          
      if(this.chkSingYes){
         this.model.possuiCertificadoDigital = "1";    
         this.chkPessoaFisica = true;
        }
      if(!this.chkSingYes){
  
      this.model.possuiCertificadoDigital = "0";
      
        this.fornecedorDeclaracaoVm.lista.forEach(item => {
            if (
              (item.uploadDeclaracao.tipDocumento === 161 || item.uploadDeclaracao.tipDocumento === 162 || item.uploadDeclaracao.tipDocumento === 150) &&
              item.uploadDeclaracao.arquivoUpload !== null
            ) {
              item.file.novo = true;
              item.uploadDeclaracao.arquivoUpload = null;
            }
          });
      
          this.model.uploadDeclaracao.forEach(item => {
            if (
              (item.tipDocumento === 161 || item.tipDocumento === 162 || item.tipDocumento === 150) &&
              item.arquivoUpload !== null
              
            ) {
              
                 item = null;
            }
          });

      }

     // this.chkPessoaFisica = null;
    
     // if(this.chkSingYes){
     // this.termoConcordancia(3);
     // }
     // else{        
     //   this.termoConcordancia(1);
     // }
    //  this.dialogTermo = this.chkSingYes !== null;
    },
    obterDialogTermoRef(value) {
      this.dialogTermo = value;
    },

  }
};
</script>

<style scoped >
  .titulo {

    text-transform:uppercase;
    font-weight:bold;
    color:#349fbe

  }

</style>